import HelpIcon from '@mui/icons-material/Help';
import { Box, Typography } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import React, { ReactElement, useState } from 'react';
import { TooltipStyle } from './styled';

interface TooltipDecoratorProps {
  title: string;
  showTooltip: boolean;
  children: ReactElement<any, any>;
  disableMouseInteraction?: boolean;
}

export const TooltipDecorator: React.FC<TooltipDecoratorProps> = ({
  title,
  showTooltip,
  children,
  disableMouseInteraction = false
}) => {
  const [open, setOpen] = useState(false);

  const handleMouseInteraction = () => {
    if (!disableMouseInteraction) {
      setOpen(prev => !prev);
    }
  }

  if (showTooltip) {
    return (
      <Box sx={{ position: 'relative' }}>
        <Tooltip
          placement='top'
          onMouseOver={handleMouseInteraction}
          onMouseLeave={handleMouseInteraction}
          componentsProps={{
            tooltip: {
              sx: TooltipStyle
            },
            popper: {
              sx: {
                '&.MuiTooltip-popper[data-popper-placement*="top"] .MuiTooltip-tooltip': {
                  m: 0
                }
              }
            }
          }}
          title={<Typography sx={{ fontSize: '10px', m: 0, p: 0 }} onClick={() => setOpen(false)}>{title}</Typography>}
          open={open}
        >
          {children}
        </Tooltip>
        <HelpIcon sx={{ position: 'absolute', right: '10px', top: '10px' }} onClick={() => setOpen(!open)} />
      </Box>
    );
  } else {
    return <>{children}</>;
  }
};
